import { useMemoizedFn as s } from "ahooks";
function f({
  elRef: u,
  onChange: e,
  onKeyDown: r,
  enabled: c = !0
}) {
  const l = s((t) => {
    if (c) {
      const a = t.target.value, i = a.replace(/[\r\n\v]+/g, "");
      a !== i && u.current && (u.current.value = i);
    }
    e == null || e(t);
  }), n = s((t) => {
    c && t.key === "Enter" && t.preventDefault(), r == null || r(t);
  });
  return {
    onChange: l,
    onKeyDown: n
  };
}
export {
  f as usePreventNewline
};
